import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  ref: "attribute-form",
  class: "p-mt-4 p-mx-4 kn-flex-0"
}
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "kn-material-input-label" }
const _hoisted_13 = { class: "p-fluid p-formgrid p-grid p-mt-4" }
const _hoisted_14 = { class: "p-field p-col-12 p-md-6 p-mt-2" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { class: "kn-material-input-label" }
const _hoisted_17 = { class: "p-field p-col-12 p-md-6 p-mt-2" }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = { class: "kn-material-input-label" }
const _hoisted_20 = { class: "p-field p-col-12 p-md-6 p-mt-2" }
const _hoisted_21 = { class: "p-float-label" }
const _hoisted_22 = { class: "kn-material-input-label" }
const _hoisted_23 = { class: "p-field p-col-12 p-md-6 p-mt-2" }
const _hoisted_24 = { class: "p-float-label" }
const _hoisted_25 = { class: "kn-material-input-label" }
const _hoisted_26 = { class: "p-field p-col-12 p-md-6 p-mt-2" }
const _hoisted_27 = { class: "p-float-label" }
const _hoisted_28 = { class: "kn-material-input-label" }
const _hoisted_29 = {
  key: 0,
  class: "p-field p-col-12 p-md-6 p-mt-2"
}
const _hoisted_30 = { class: "p-float-label" }
const _hoisted_31 = {
  for: "physicalColumn",
  class: "kn-material-input-label"
}
const _hoisted_32 = { class: "p-field p-col-12 p-md-6 p-mt-2" }
const _hoisted_33 = { class: "p-float-label" }
const _hoisted_34 = { class: "kn-material-input-label" }
const _hoisted_35 = {
  key: 1,
  class: "p-field p-col-12 p-md-6 p-mt-2"
}
const _hoisted_36 = { class: "p-float-label" }
const _hoisted_37 = { class: "kn-material-input-label" }
const _hoisted_38 = {
  key: 2,
  class: "p-field p-col-12 p-md-6 p-mt-2"
}
const _hoisted_39 = { class: "p-float-label" }
const _hoisted_40 = { class: "kn-material-input-label" }
const _hoisted_41 = { class: "p-field p-col-12 p-md-6 p-mt-2" }
const _hoisted_42 = { class: "p-float-label" }
const _hoisted_43 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "metaweb-attribute-detail-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.metawebAttributeDetailDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.attributesDetail.title')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.saveAttribute
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      (_ctx.attribute)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", _hoisted_4, [
                  _createVNode(_component_InputText, {
                    id: "name",
                    class: "kn-material-input",
                    modelValue: _ctx.attribute.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.attribute.name = $event)),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.name')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, [
                  _createVNode(_component_InputText, {
                    id: "name",
                    class: "kn-material-input",
                    modelValue: _ctx.attribute.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.attribute.description = $event)),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.description')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("span", _hoisted_10, [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    modelValue: _ctx.columnType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.columnType = $event)),
                    options: _ctx.metawebAttributeDetailDialogDescriptor.typeOptions,
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onTypeChange()))
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('common.type')), 1)
                ])
              ])
            ]),
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('metaweb.businessModel.attributesDetail.structural')), 1),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("span", _hoisted_15, [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    modelValue: _ctx.properties['structural.aggtype'].value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.properties['structural.aggtype'].value = $event)),
                    options: _ctx.properties['structural.aggtype'].propertyType.admissibleValues,
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateAttribute('structural.aggtyp')))
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_16, _toDisplayString(_ctx.properties['structural.aggtype'].propertyType.name), 1),
                  _createVNode("small", null, _toDisplayString(_ctx.properties['structural.aggtype'].propertyType.description), 1)
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("span", _hoisted_18, [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    modelValue: _ctx.properties['structural.datatype'].value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.properties['structural.datatype'].value = $event)),
                    options: _ctx.properties['structural.datatype'].propertyType.admissibleValues,
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateAttribute('structural.datatype')))
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_19, _toDisplayString(_ctx.properties['structural.datatype'].propertyType.name), 1),
                  _createVNode("small", null, _toDisplayString(_ctx.properties['structural.datatype'].propertyType.description), 1)
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("span", _hoisted_21, [
                  _createVNode(_component_MultiSelect, {
                    class: "kn-material-input",
                    modelValue: _ctx.properties['behavioural.notEnabledRoles'].value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.properties['behavioural.notEnabledRoles'].value = $event)),
                    options: _ctx.roleOptions,
                    optionLabel: "name",
                    optionValue: "name",
                    filter: true,
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateAttribute('behavioural.notEnabledRoles')))
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_22, _toDisplayString(_ctx.properties['behavioural.notEnabledRoles'].propertyType.name), 1),
                  _createVNode("small", null, _toDisplayString(_ctx.properties['behavioural.notEnabledRoles'].propertyType.description), 1)
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("span", _hoisted_24, [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    modelValue: _ctx.properties['structural.attribute'].value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.properties['structural.attribute'].value = $event)),
                    options: _ctx.profileAttributes,
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateAttribute('structural.attribute')))
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_25, _toDisplayString(_ctx.properties['structural.attribute'].propertyType.name), 1),
                  _createVNode("small", null, _toDisplayString(_ctx.properties['structural.attribute'].propertyType.description), 1)
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("span", _hoisted_27, [
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: _ctx.properties['physical.physicaltable'].value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.properties['physical.physicaltable'].value = $event)),
                    modelModifiers: { trim: true },
                    disabled: true
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_28, _toDisplayString(_ctx.properties['physical.physicaltable'].propertyType.name), 1),
                  _createVNode("small", null, _toDisplayString(_ctx.properties['physical.physicaltable'].propertyType.description), 1)
                ])
              ]),
              (_ctx.attribute.physicalColumn)
                ? (_openBlock(), _createBlock("div", _hoisted_29, [
                    _createVNode("span", _hoisted_30, [
                      _createVNode(_component_InputText, {
                        id: "physicalColumn",
                        class: "kn-material-input",
                        modelValue: _ctx.attribute.physicalColumn.name,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.attribute.physicalColumn.name = $event)),
                        modelModifiers: { trim: true },
                        disabled: true
                      }, null, 8, ["modelValue"]),
                      _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('metaweb.businessModel.physicalColumn')), 1),
                      _createVNode("small", null, _toDisplayString(_ctx.$t('metaweb.businessModel.physicalColumnHint')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_32, [
                _createVNode("span", _hoisted_33, [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    modelValue: _ctx.properties['structural.filtercondition'].value,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.properties['structural.filtercondition'].value = $event)),
                    options: _ctx.properties['structural.filtercondition'].propertyType.admissibleValues,
                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateAttribute('structural.filtercondition')))
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_34, _toDisplayString(_ctx.properties['structural.filtercondition'].propertyType.name), 1),
                  _createVNode("small", null, _toDisplayString(_ctx.properties['structural.filtercondition'].propertyType.description), 1)
                ])
              ]),
              (_ctx.properties['structural.datatype'].value === 'DATE' || _ctx.properties['structural.datatype'].value === 'TIMESTAMP' || _ctx.properties['structural.datatype'].value === 'TIME')
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    _createVNode("span", _hoisted_36, [
                      _createVNode(_component_Dropdown, {
                        class: "kn-material-input",
                        modelValue: _ctx.properties['structural.dateformat'].value,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.properties['structural.dateformat'].value = $event)),
                        options: _ctx.properties['structural.dateformat'].propertyType.admissibleValues,
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateAttribute('structural.dateformat')))
                      }, {
                        option: _withCtx((slotProps) => [
                          _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(new Date(), slotProps.option)), 1)
                        ]),
                        value: _withCtx((slotProps) => [
                          _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(new Date(), slotProps.value)), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"]),
                      _createVNode("label", _hoisted_37, _toDisplayString(_ctx.properties['structural.dateformat'].propertyType.name), 1),
                      _createVNode("small", null, _toDisplayString(_ctx.properties['structural.datatype'].value === 'TIME' ? _ctx.properties['structural.format'].propertyType.description : _ctx.properties['structural.dateformat'].propertyType.description), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (['INTEGER', 'DOUBLE', 'DECIMAL', 'BIGINT', 'FLOAT'].indexOf(_ctx.properties['structural.datatype'].value) !== -1)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _createVNode("span", _hoisted_39, [
                      _createVNode(_component_Dropdown, {
                        class: "kn-material-input",
                        modelValue: _ctx.properties['structural.format'].value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.properties['structural.format'].value = $event)),
                        options: _ctx.properties['structural.format'].propertyType.admissibleValues,
                        onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateAttribute('structural.format')))
                      }, null, 8, ["modelValue", "options"]),
                      _createVNode("label", _hoisted_40, _toDisplayString(_ctx.properties['structural.format'].propertyType.name), 1),
                      _createVNode("small", null, _toDisplayString(_ctx.properties['structural.format'].propertyType.description), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_41, [
                _createVNode("span", _hoisted_42, [
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: _ctx.properties['structural.customFunction'].value,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.properties['structural.customFunction'].value = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateAttribute('structural.customFunction')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_43, _toDisplayString(_ctx.properties['structural.customFunction'].propertyType.name), 1),
                  _createVNode("small", null, _toDisplayString(_ctx.properties['structural.customFunction'].propertyType.description), 1)
                ])
              ])
            ])
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}